<template>
  <div :id="`${source}_crm_properties_select`" class="w-full p-4">
    <SearchableMultiSelectDropdown
      v-model="selectedValue"
      :options="transformedFields"
      :multiple="false"
      placeholder="Select property"
      search-title="Choose Property"
      search-placeholder="Search properties..."
      empty-state-text="No properties found"
      :disabled="false"
      @selection-change="handleFieldChange"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

import eventBus from "@/src/utils/eventBus.js";
import SearchableMultiSelectDropdown from "@/src/components/SearchableMultiSelectDropdown.vue";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
  extraData: { type: Object, required: true },
});

const selectedValue = ref(null);
const availableFields = ref(props.extraData || []);

// Transform the fields data to match the expected format
const transformedFields = computed(() => {
  return availableFields.value.map(field => ({
    value: field.field_key || field.value,
    label: field.label || field.field_label || field.name,
    ...field // Keep all other properties
  }));
});

// Initialize selected value
onMounted(() => {
  selectedValue.value = props.row?.crm_field_key || null;
});

const handleFieldChange = (value) => {
  const field = availableFields.value?.find((item) => item.field_key === value);
  const updatedRow = {
    ...props.row,
    crm_field_key: value,
    crm_field_label: field?.label || '',
    originalField: props.row.crm_field_key,
    read_only: field?.read_only === true,
  };
  eventBus.emit("crm-properties-change", updatedRow);
};
</script>
